import { ResourcesConfig } from 'aws-amplify';

const identityPoolId = process.env.NEXT_PUBLIC_COGNITO_IDENTITY_POOL_ID || '';
const userPoolId = process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID || '';
const userPoolClientId =
  process.env.NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID || '';
const oauthDomain =
  process.env.NEXT_PUBLIC_COGNITO_OAUTH_DOMAIN ||
  'eu-west-2b7avq9ozp.auth.eu-west-2.amazoncognito.com/';
const redirectSignIn = process.env.NEXT_PUBLIC_COGNITO_REDIRECT_SIGN_IN?.split(
  ',',
) || ['http://localhost:4501/auth/callback'];
const redirectSignOut =
  process.env.NEXT_PUBLIC_COGNITO_REDIRECT_SIGN_OUT?.split(',') || [
    'http://localhost:4501/auth/callback',
  ];
const scopes = process.env.NEXT_PUBLIC_COGNITO_USER_POOL_SCOPES?.split(',') || [
  'email',
  'openid',
  'profile',
  'aws.cognito.signin.user.admin',
  'email',
];

const responseTypeVar: 'code' | 'token' = 'code';

export const awsExports: ResourcesConfig = Object.freeze({
  Auth: {
    Cognito: {
      identityPoolId,
      userPoolId,
      userPoolClientId,
      loginWith: {
        oauth: {
          domain: oauthDomain,
          scopes,
          redirectSignIn,
          redirectSignOut,
          responseType: responseTypeVar,
        },
      },
    },
  },
});
